import { motion } from 'framer-motion';
import {NavLink} from 'react-router-dom'
import FourBox1 from '../../assets/FourBox/FourBox1.webp'
import FourBox2 from '../../assets/FourBox/FourBox2.jpg'
import FourBox3 from '../../assets/FourBox/FourBox3.jpg'
import FourBox4 from '../../assets/FourBox/FourBox4.avif'

const services = [
  { id: 1, title: "1:1 Consultation Booking", image: FourBox1 },
  { id: 2, title: "Customizable Scheduling & Availability", image: FourBox2 },
  { id: 3, title: "Personalized Profile & Service Offerings", image: FourBox3 },
  { id: 4, title: "Referral & Affiliate System", image: FourBox4 }
];

const ServiceCards = () => {
  return (
    <div className="bg-[#EAF1FB] min-h-screen flex flex-col items-center justify-center">
      <h2 className="text-black text-3xl font-bold mb-8 px-2 text-center pt-5">Our Solutions In More Detail</h2>
      <div className="flex flex-wrap justify-center pb-5 gap-6">
        {services.map((service, index) => (
          <div
            key={service.id}
            className="bg-gradient-to-b from-[#1A3E72] to-[#2F80ED] rounded-2xl p-4 w-60 text-center shadow-lg flex flex-col gap-3 justify-between"
          >
            <motion.img 
              src={service.image} 
              alt={service.title} 
              className="w-full h-40 object-cover rounded-lg"
              animate={{
                y: [0, 0, -50],
                opacity: [1, 1, 0]
              }}
              transition={{
                duration: 1,
                delay: index * 0.5,
                repeat: Infinity,
                repeatType: "loop",
                repeatDelay: 2
              }}
              initial={{ y: 50, opacity: 0 }}
            />
            <h3 className="text-white font-semibold mt-4">{service.title}</h3>
            <NavLink to={'/about'} className="secondary-btn">LEARN MORE</NavLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCards;